'use client';

/**
 * Delete Item Button - Remove item from cart
 * Exactly like Vercel Commerce
 */

import { XMarkIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';

export function DeleteItemButton({ onClick }: { onClick: () => void }) {
    return (
        <button
            type="button"
            onClick={onClick}
            aria-label="إزالة من السلة"
            className={clsx(
                'ease flex h-[24px] w-[24px] items-center justify-center rounded-full bg-neutral-500 transition-all duration-200'
            )}
        >
            <XMarkIcon className="mx-[1px] h-4 w-4 text-white dark:text-black" />
        </button>
    );
}
